import { UserGroupIcon } from "@heroicons/react/outline"
import { CogIcon, CreditCardIcon, PhotographIcon } from "blx-icons"
import type { FeaturesActive } from "lib/feature-flags/generated/hypertune"
import { ScreenPaths } from "../routing"
import type { NavigationLinkItem } from "./types/NavigationLinkItem"

type OrgLinks = {
    [property in "team" | "settings" | "billing" | "mediaLibrary"]: NavigationLinkItem
}

export const organizationConfig = (activeFeatures: FeaturesActive): NavigationLinkItem[] => {
    const links: OrgLinks = {
        mediaLibrary: {
            label: "Media Library",
            path: ScreenPaths.MediaLibrary,
            displayType: "link",
            isDisabled: false,
            icon: PhotographIcon,
            showLink: activeFeatures.orgs.media
        },
        team: {
            label: "Team Management",
            path: ScreenPaths.TeamManagement,
            displayType: "link",
            isDisabled: false,
            icon: UserGroupIcon,
            showLink: activeFeatures.orgs.team
        },
        settings: {
            label: "Settings",
            path: ScreenPaths.OrgSettings,
            displayType: "link",
            isDisabled: false,
            icon: CogIcon,
            showLink: activeFeatures.orgs.settings
        },
        billing: {
            label: "Billing & Payment",
            path: ScreenPaths.Billing,
            displayType: "link",
            isDisabled: false,
            icon: CreditCardIcon,
            showLink: activeFeatures.orgs.billing
        }
    }

    return [links.mediaLibrary, links.team, links.billing, links.settings]
}
